module.exports = __webpack_public_path__ + "img/success.52bbd9c6.svg";